import { Paper, PaperProps } from '@mui/material';

interface ContentCardProps extends PaperProps {
  children: React.ReactNode;
}

const ContentCard = ({ children, sx, ...props }: ContentCardProps) => {
  return (
    <Paper
      sx={{
        borderRadius: '10px',
        boxShadow: '0 10px 30px rgba(146,153,184,0.15)',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default ContentCard;
